<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a [routerLink]="['/home']">Home</a>
            </li>
            <li class="breadcrumb-item">
                <a [routerLink]="['/customers']">Customers</a>
            </li>
            <li class="breadcrumb-item" *ngIf="customer">
                <a [routerLink]="['/customers', customer.customerId]">{{ customer.customerName || "-" }}</a>
            </li>
            <li class="breadcrumb-item" *ngIf="productInstance">
                <a>{{ productInstance?.product?.productName || "Product" }} <span *ngIf="productInstance.instanceName"> ({{productInstance.instanceName}})</span></a>
            </li>
        </ol>
    </div>
</div>

<div class="wrapper wrapper-content">
    <div class="row">
        <div class="col-lg-8 col-md-12">
            <div class="card mt-2 bg-emphasis bg-opacity-25">
                <div class="card-header">
                    <div class="d-flex fw-bold small mb-3">
                        <span class="flex-grow-1">
                            <h5>Licenses</h5>                        
                        </span>   
                        <span>
                            <button class="btn btn-primary btn-sm" (click)="openLicenseModal()">Add License</button>
                        </span>
                    </div> 
                </div>
                <div class="card-body">
                    <ng-table [tableKeys]="licenseTableKeys" [tableRows]="licenses" [isUpdateEnabled]="true" [isFileDownload]="true" 
                        [isRowReplace]="true" (updateRowEvent)="beginUpdateLicense($event)" (downloadRowEvent)="downloadLicense($event)" 
                        (replaceRowEvent)="beginReplaceLicense($event)" (deleteRowEvent)="deleteLicense($event)"></ng-table>
                </div> 
        
            </div>

            <div class="card mt-3 bg-emphasis bg-opacity-25">
                <div class="card-header">
                    <div class="d-flex fw-bold small">
                        <span class="flex-grow-1">
                            <h5>Certificates</h5>                        
                        </span>   
                        <span>
                            <button class="btn btn-primary btn-xs" (click)="openCertificateModal()">Add Certificate</button>
                        </span>
                    </div>
                </div>
                <div class="card-body">
                    <ng-table [tableKeys]="certificateTableKeys" [tableRows]="certificates" [isUpdateEnabled]="true" [isFileDownload]="true" [isRowReplace]="true" (updateRowEvent)="beginUpdateCertificate($event)" (downloadRowEvent)="downloadCertificate($event)" (replaceRowEvent)="beginReplaceCertificate($event)" (deleteRowEvent)="deleteCertificate($event)"></ng-table>
                </div>    
            </div>

            <!-- Files Display -->
            <!--<div class="row">
                <div class="col-lg-6">
                    <div class="card mt-3">
                        <div class="card-header">
                            <h5>Files</h5>
                        </div>
                        <div class="card-body">
                            <app-file-list [files]="files" (downloadEvent)="downloadFileByUri($event)"></app-file-list>
                        </div>
                        
                        <div class="card-arrow">
                            <div class="card-arrow-top-left"></div>
                            <div class="card-arrow-top-right"></div>
                            <div class="card-arrow-bottom-left"></div>
                            <div class="card-arrow-bottom-right"></div>
                        </div>
                    </div>
                </div>
            </div>-->
        </div>

        <div class="col-lg-4 col-md-12">
            <div class="card mt-2 bg-emphasis bg-opacity-25">
                <div class="card-header">
                    <h5>Product Alerts</h5>
                </div>
                <div class="card-body bg-opacity-5 bg-white">
                    <app-alerts [alerts]="productInstanceAlerts"></app-alerts>
                </div>      
            </div>
            
        </div>
    </div>
</div>

<!-- License Modal -->
<div class="modal fade" bsModal #licenseModal="bs-modal" tabindex="-1" role="dialog" (onHidden)="closeLicenseModal()">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-left">{{ isUpdatingLicense ? "Update" : isReplacingLicense ? "Replace" : "Create" }} License</h4>


                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeLicenseModal()"></button>
            </div>
            <!-- Form -->
            <form class="modal-form" (ngSubmit)="saveLicense()" [formGroup]="licenseGroupModel">
                <div class="modal-body" *ngIf="this.isReplacingLicense">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label">Extend By</label>
                        <div class="col-sm-8">
                            <select class="form-select" formControlName="extendByMonths" [(ngModel)]="extendByMonths">
                                <option value="12">12 Months</option>
                                <option value="6">6 Months</option>
                                <option value="3">3 Months</option>
                                <option value="1">1 Months</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label">Price</label>
                        <div class="col-sm-8">
                            <input class="form-control" autocomplete="off" type="number" formControlName="price" [(ngModel)]="licensePrice">
                        </div>
                    </div>
                </div>
                <div class="modal-body" *ngIf="!this.isReplacingLicense">
                    <div class="form-group row" [class.has-error]="licenseGroupModel.controls['issuedDate'].invalid && licenseGroupModel.controls['issuedDate'].touched">
                        <label class="col-sm-4 col-form-label">Issued Date</label>
                        <div class="col-sm-8">
                            <input
                                bsDatepicker [bsConfig]="bsDatePickerConfig" 
                                class="form-control input-date-picker" autocomplete="off" type="text" formControlName="issuedDate">
                        </div>
                    </div>
                    <div class="hr-line-dashed"></div>
                    <div class="form-group row" [class.has-error]="licenseGroupModel.controls['expiredDate'].invalid && licenseGroupModel.controls['expiredDate'].touched">
                        <label class="col-sm-4 col-form-label">Expired Date</label>
                        <div class="col-sm-8">
                            <input
                                bsDatepicker [bsConfig]="bsDatePickerConfig" 
                                class="form-control input-date-picker" autocomplete="off" type="text" formControlName="expiredDate">
                        </div>
                    </div>
                    <div class="hr-line-dashed"></div>
                    <div class="form-group row" [class.has-error]="licenseGroupModel.controls['price'].invalid && licenseGroupModel.controls['price'].touched">
                        <label class="col-sm-4 col-form-label">Price</label>
                        <div class="col-sm-8">
                            <input class="form-control" autocomplete="off" type="number" formControlName="price">
                        </div>
                    </div>
                    <div class="hr-line-dashed"></div>
                    <div class="form-group row" [class.has-error]="licenseGroupModel.controls['licenseKey'].invalid && licenseGroupModel.controls['licenseKey'].touched">
                        <label class="col-sm-4 col-form-label">License Key</label>
                        <div class="col-sm-8">
                            <input class="form-control" autocomplete="off" type="text" formControlName="licenseKey">
                        </div>
                    </div>
                    <div class="hr-line-dashed"></div>
                    <div class="form-group row" [class.has-error]="licenseGroupModel.controls['licenseNumber'].invalid && licenseGroupModel.controls['licenseNumber'].touched">
                        <label class="col-sm-4 col-form-label">License Number</label>
                        <div class="col-sm-8">
                            <input class="form-control" autocomplete="off" type="text" formControlName="licenseNumber">
                        </div>
                    </div>
                    <div class="hr-line-dashed"></div>
                    <div class="form-group row" [class.has-error]="licenseGroupModel.controls['licenseTypeId'].invalid && licenseGroupModel.controls['licenseTypeId'].touched">
                        <label class="col-sm-4 col-form-label">License Type</label>
                        <div class="col-sm-8">
                            <select class="form-select" formControlName="licenseTypeId">
                                <option *ngFor="let licenseType of licenseTypes" [value]="licenseType.licenseTypeId">{{ licenseType.licenseName }}</option>
                            </select>
                        </div>
                    </div>
                    <ng-container *ngIf="isUpdatingLicense">
                        <div class="hr-line-dashed"></div>
                        <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="onLicenseFileDrop($event)" multiple="false">
                            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                                Drag File Here
                                <button class="upload-file-btn btn btn-default" type="button" (click)="openFileSelector()">Or Upload</button>
                            </ng-template>
                        </ngx-file-drop>
                    </ng-container>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" type="button" (click)="closeLicenseModal()">Cancel</button>
                    <button class="btn btn-primary" *ngIf="!isReplacingLicense" type="submit" [disabled]="!isReplacingLicense && !licenseGroupModel.valid">{{ isUpdatingLicense ? "Update" : isReplacingLicense ? "Replace" : "Create" }} License</button>
                    <button class="btn btn-primary" *ngIf="isReplacingLicense" type="submit">Replace License</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Certificate Modal -->
<div class="modal fade" bsModal #certificateModal="bs-modal" tabindex="-1" role="dialog" (onHidden)="closeCertificateModal()">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-left">{{ isUpdatingCertificate ? "Update" : isReplacingCertificate ? "Replace" : "Create" }} Certificate</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="closeCertificateModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <!-- Form -->
            <form class="modal-form" (ngSubmit)="saveCertificate()" [formGroup]="certificateGroupModel">
                <div class="modal-body">
                    <div class="form-group row" [class.has-error]="certificateGroupModel.controls['issuedDate'].invalid && certificateGroupModel.controls['issuedDate'].touched">
                        <label class="col-sm-4 col-form-label">Issued Date</label>
                        <div class="col-sm-8">
                            <input
                                bsDatepicker [bsConfig]="bsDatePickerConfig" 
                                class="form-control input-date-picker" autocomplete="off" type="text" formControlName="issuedDate">
                        </div>
                    </div>
                    <div class="hr-line-dashed"></div>
                    <div class="form-group row" [class.has-error]="certificateGroupModel.controls['expiredDate'].invalid && certificateGroupModel.controls['expiredDate'].touched">
                        <label class="col-sm-4 col-form-label">Expired Date</label>
                        <div class="col-sm-8">
                            <input
                                bsDatepicker [bsConfig]="bsDatePickerConfig" 
                                class="form-control input-date-picker" autocomplete="off" type="text" formControlName="expiredDate">
                        </div>
                    </div>
                    <div class="hr-line-dashed"></div>
                    <div class="form-group row" [class.has-error]="certificateGroupModel.controls['certificateName'].invalid && certificateGroupModel.controls['certificateName'].touched">
                        <label class="col-sm-4 col-form-label">Certificate Name</label>
                        <div class="col-sm-8">
                            <input class="form-control" autocomplete="off" type="text" formControlName="certificateName">
                        </div>
                    </div>
                    <ng-container *ngIf="isUpdatingCertificate">
                        <div class="hr-line-dashed"></div>
                        <!-- todo - display current uploaded file, show download link -->
                        <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="onCertificateFileDrop($event)" multiple="false">
                            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                                Drag File Here
                                <button class="upload-file-btn btn btn-default" type="button" (click)="openFileSelector()">Or Upload</button>
                            </ng-template>
                        </ngx-file-drop>
                    </ng-container>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" type="button" (click)="closeCertificateModal()">Cancel</button>
                    <button class="btn btn-primary" type="submit" [disabled]="!certificateGroupModel.valid">{{ isUpdatingCertificate ? "Update" : isReplacingCertificate ? "Replace" : "Create" }} Certificate</button>
                </div>
            </form>
        </div>
    </div>
</div>